import React from 'react';
import $ from "jquery";
import Dialog from '@material-ui/core/Dialog';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogContent from '@material-ui/core/DialogContent';
import DialogActions from '@material-ui/core/DialogActions';
import Button from '@material-ui/core/Button';
import { Input, Grid, Dropdown, Form, TextArea } from 'semantic-ui-react';
import FormControl from '@material-ui/core/FormControl';
import Select from '@material-ui/core/Select';
import MenuItem from '@material-ui/core/MenuItem';

import ReadCookie from '../../../functions/readcookies';
import Loading from '../../loading';
import Server from '../../../functions/server';

export default class JobCard extends React.Component {

    state = {
        values: {}, data: [], spares: [], modeOption: [], mode: 0
    }

      getSpares = () => {
        let context = this;
        context.setState({ load: true, message: 'Getting Customer And Labor Details', })
        $.ajax({
            type: 'POST', data: { 'jobcard_id': this.props.item.id }, url: Server() + 'Sales/JobCard/getSpares.php',
            success: function (data) {
                console.log(data);
                try {
                    data = JSON.parse(data);
                    let spares = [];
                    data.map((c) => {
                      if (c.sparestatus == 'Process') {
                        spares.push(c);
                      }
                    })
                    context.removeduplicatespares(spares);
                    
                } catch (error) {
                    context.setState({ load: false })
                    alert(error)
                }
            },
            error: function (e) {
                alert('Try again1!!')
                context.setState({ load: false });
            }
        });
      }
    
      generateInvoice = () => {
        let context = this;
        let spares = this.state.spares;
        let item = this.props.item;
        let mode = this.state.mode;
        spares = JSON.stringify(spares);
        context.setState({ load: true, message: 'Generate Invoice', })
        let url = Server() + 'Sales/JobCard/GenerateInvoice.php';
        let data = { 'id': item.id, spares, mode };
        if (this.state.status == 'Completed') {
          url = Server() + 'Sales/JobCard/CancelInvoice.php';
          data = { 'id': item.id, spares };
        }
        console.log(url);
        console.log(data);
        $.ajax({
            type: 'POST', data, 
            url: url,
            success: function (data) {
              console.log(data);
              if (data == 1) {
                context.props.refresh();
                context.setState({ load: false, dialog: false })
              }
              else {
                context.props.refresh();
                context.setState({ load: false, dialog: false })
              }
            },
            error: function (e) {
                alert('Try again1!!')
                context.setState({ load: false });
            }
        });
      }

      convertIntoNumber(value) {
        try {
            value = Number(value);
        } catch (error) {
            value = 0;
        }
        return value;
    }

    makeDecimal(value) {
        try {
            value = value.toFixed(2);
        } catch (error) {
            value = 0;
        }
        return value;
    }

    getLedger(type) {
      let context = this;
      let cook = (ReadCookie("vaigai"));
      let userId = cook.id;
      this.setState({ load: true, message: 'Get Ledger!!!' })
      $.ajax({
          type: 'POST', data: { 'userId': userId },
          url: Server() + 'addmenu/mode/get.php',
          success: function (data) {
            console.log(data);
            try {
              data = JSON.parse(data);
              let modeOption = [];
              modeOption.push({ key: 'Credit', text: 'Credit', value: 0 })
              data.map((c) => {
                modeOption.push({ key: c.mode, text: c.mode, value: c.id })
              })
              context.setState({ load: false, dialog: true, status: type, modeOption })
            } catch (error) {
              alert('Error')
            }
          },
          error: function (e) {
              alert('Try again1!!')
              context.setState({ load: false });
          }
      });
    }

    removeduplicatespares = (spares) => {
      let unique = spares.filter((v,i,a)=>a.findIndex(t=>(t.partno === v.partno))===i)
      unique.map((v) => {
        let discount = 0;
        let qty = 0;
        let uprice = this.convertIntoNumber(v.uprice);
        let tax = this.convertIntoNumber(v.tax);
        spares.map((c) => {
          if (c.partno == v.partno) {
            let discper = this.convertIntoNumber(c.discper);
            let uprices = this.convertIntoNumber(c.uprice);
            qty = qty + this.convertIntoNumber(c.qty);
            if (discper) {
              discount = discper;
              uprice = uprices;
            }
          }
        })
        discount = discount;
        v.discper = discount;
        v.uprice = uprice;
        v.qty = qty;
        let mrp = uprice + ((uprice * tax)/100);
        v.mrp = mrp;
        v.totprice = mrp * qty;
        let discrs = (mrp * qty) + (((mrp * qty) * discount)/100);
        discrs = discrs - (mrp * qty)
        v.discrs = discrs;
      })
      this.setState({ ViewSparesDialog: true, spares: unique, load: false })
    }

    mode = (f, { value }) => {
      this.setState({ mode: value });
    }

    render() {
        let { load, dialog, ViewSparesDialog, spares, modeOption } = this.state;
        let i = 1;
        return (
            <div>
                {
                    this.props.item.status == 1 || this.props.item.status == '1' ? 
                    <div style={{color: 'blue', cursor: 'pointer'}} onClick={ () => this.getLedger('Process')}>Process</div> : 
                    <div style={{color: 'green'}} onClick={ () => this.getLedger('Completed')}>Completed</div>
                }
                <Dialog fullWidth={false} maxWidth={'md'} open={dialog}
                    onClose={ () => { this.setState({ dialog: false }) }}>
                    <DialogTitle id="responsive-dialog-title" style={{width: '500px'}}> {"Change Job Status"} </DialogTitle>
                    <DialogContent>
                        Are you confirm to change this job status ?<br/><br/>
                        { this.state.status == 'Process' ?
                          <div>
                            <b>Select Payment Mode</b><br/>
                            <Dropdown fluid onChange={this.mode}
                              search selection options={modeOption}
                              value={this.state.mode} /><br/><br/><br/><br/><br/>
                          </div> : null
                        }
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={ () => this.generateInvoice()}>Yes</Button>
                        <Button onClick={ () => { this.setState({ dialog: false }) }}>No</Button>
                    </DialogActions>
                </Dialog>

                <Dialog fullWidth={false} maxWidth={'lg'} open={ViewSparesDialog}
                    onClose={ () => { this.setState({ ViewSparesDialog: false }) }}>
                    <DialogTitle id="responsive-dialog-title" style={{width: '900px'}}> {"Duplicate Spares Removed"} </DialogTitle>
                    <DialogContent>
                      <table width="100%" id="table">
                          <tr>
                              <th id='tableheader'><center>Sino</center></th>
                              <th id='tableheader'><center>Serial Number</center></th>
                              <th id='tableheader'><center>Partno</center></th>
                              <th id='tableheader'><center>Spare Name</center></th>
                              <th id='tableheader'><center>Rate</center></th>
                              <th id='tableheader'><center>MRP</center></th>
                              <th id='tableheader'><center>QTY</center></th>
                              <th id='tableheader'><center>Dis%</center></th>
                              <th id='tableheader'><center>Dis Rs</center></th>
                              <th id='tableheader'><center>Taxable Price</center></th>
                              <th id='tableheader'><center>TAX</center></th>
                              <th id='tableheader'><center>Tax Price</center></th>
                              <th id='tableheader'><center>Total</center></th>
                             
                          </tr>
                          {
                              spares.map((c) => {
                                let uprice = this.convertIntoNumber(c.uprice);
                                let qty = this.convertIntoNumber(c.qty);
                                let tax = this.convertIntoNumber(c.tax);
                                let discper = this.convertIntoNumber(c.discper);
                                let totprice = this.convertIntoNumber(c.totprice);
                                let mrp = uprice + ((uprice * tax)/100);
                                let taxableprice = (mrp * qty) - (uprice * qty);
                                return (
                                    <tr>
                                        <td>{i++}</td>
                                        <td>{c.serial_number}</td>
                                        <td>{c.partno}</td>
                                        <td>{c.spare_name}</td>
                                        <td style={{textAlign: 'right'}}>{this.makeDecimal(uprice)}</td>
                                        <td style={{textAlign: 'right'}}>{this.makeDecimal(mrp)}</td>
                                        <td style={{textAlign: 'right'}}>{c.qty}</td>
                                        <td style={{textAlign: 'right'}}>{this.makeDecimal(this.convertIntoNumber(c.discper))}</td>
                                        <td style={{textAlign: 'right'}}>{this.makeDecimal(this.convertIntoNumber(c.discrs))}</td>
                                        <td style={{textAlign: 'right'}}>{this.makeDecimal(uprice * qty)}</td>
                                        <td style={{textAlign: 'right'}}>{c.tax}</td>
                                        <td style={{textAlign: 'right'}}>{this.makeDecimal(taxableprice)}</td>
                                        <td style={{textAlign: 'right'}}>{this.makeDecimal(this.convertIntoNumber(c.totprice))}</td>
                                    </tr>
                                )
                              })
                          }
                      </table>
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={this.generateInvoice}>Yes</Button>
                        <Button onClick={ () => { this.setState({ ViewSparesDialog: false }) }}>No</Button>
                    </DialogActions>
                </Dialog>
            </div>
        );
    }
}